const list = document.querySelector("[data-ship-list]");
const cards = [...document.querySelectorAll("[data-ship-card]")];
const mq = window.matchMedia("(min-width: 768px)");

const detail = document.createElement("div");
detail.className = "ship_detail";
detail.hidden = true;

let activeId = null;
let detailSwipers = [];

function getInsertTarget(card) {
  const index = cards.indexOf(card);

  if (!mq.matches) {
    return card;
  }

  const rowEndIndex = index % 2 === 0 ? index + 1 : index;
  return cards[Math.min(rowEndIndex, cards.length - 1)];
}

function openDetail(card) {
  const id = card.dataset.shipId;
  const template = document.getElementById(`ship-detail-${id}`);

  if (activeId === id && !detail.hidden) {
    closeDetail();
    return;
  }

  cards.forEach((item) => {
    item.querySelector("button").setAttribute("aria-expanded", item === card ? "true" : "false");
  });

  destroyDetailSliders();
  detail.classList.remove("is-visible");
  detail.innerHTML = "";
  detail.append(template.content.cloneNode(true));
  detail.hidden = false;

  getInsertTarget(card).after(detail);
  initDetailSliders(detail);
  initYouTubeEmbeds(detail);
  initDetailCloseButton();
  scrollToDetail();
  requestAnimationFrame(() => {
    detail.classList.add("is-visible");
  });
  activeId = id;
}

function closeDetail() {
  destroyDetailSliders();
  detail.classList.remove("is-visible");
  detail.hidden = true;
  detail.innerHTML = "";
  activeId = null;

  cards.forEach((card) => {
    card.querySelector("button").setAttribute("aria-expanded", "false");
  });
}

function initDetailSliders(scope) {
  const slider = scope.querySelector("[data-ship-detail-slider][data-slider-enabled='true']");
  if (!slider || typeof Swiper === "undefined") return;

  const mainEl = slider.querySelector("[data-ship-detail-main]");
  const thumbsEl = slider.querySelector("[data-ship-detail-thumbs]");
  if (!mainEl || !thumbsEl) return;

  const thumbsSwiper = new Swiper(thumbsEl, {
    slidesPerView: "auto",
    spaceBetween: getThumbSpaceBetween(),
    watchSlidesProgress: true,
    allowTouchMove: false,
  });

  const mainSwiper = new Swiper(mainEl, {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    speed: 600,
    slidesPerView: 1,
    thumbs: {
      swiper: thumbsSwiper,
    },
  });

  detailSwipers = [mainSwiper, thumbsSwiper];
}

function destroyDetailSliders() {
  detailSwipers.forEach((swiper) => {
    if (swiper && !swiper.destroyed) {
      swiper.destroy(true, true);
    }
  });
  detailSwipers = [];
}

function getVwValue(px) {
  const vwBase = Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--vw-base"));
  return px * (window.innerWidth / (vwBase || 1440));
}

function getThumbSpaceBetween() {
  return getVwValue(mq.matches ? 20 : 6);
}

function updateDetailSliderSpace() {
  const thumbSwiper = detailSwipers[1];
  if (!thumbSwiper || thumbSwiper.destroyed) return;

  thumbSwiper.params.spaceBetween = getThumbSpaceBetween();
  thumbSwiper.update();
}

function scrollToDetail() {
  const offset = mq.matches ? 300 : 120;
  const top = detail.getBoundingClientRect().top + window.scrollY - offset;

  window.scrollTo({
    top,
    behavior: "smooth",
  });
}

function initDetailCloseButton() {
  const closeButton = detail.querySelector("[data-ship-detail-close]");
  if (!closeButton) return;

  closeButton.addEventListener("click", closeDetail);
}

function initYouTubeEmbeds(scope) {
  const movieWraps = scope.querySelectorAll("[data-youtube-url]");

  movieWraps.forEach((movieWrap) => {
    const embedUrl = getYouTubeEmbedUrl(movieWrap.dataset.youtubeUrl);
    if (!embedUrl) return;

    const iframe = document.createElement("iframe");
    iframe.src = embedUrl;
    iframe.title = movieWrap.dataset.youtubeTitle || "YouTube video";
    iframe.loading = "lazy";
    iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
    iframe.allowFullscreen = true;

    movieWrap.append(iframe);
  });
}

function getYouTubeEmbedUrl(url) {
  if (!url) return "";

  try {
    const parsedUrl = new URL(url);
    let videoId = "";

    if (parsedUrl.hostname === "youtu.be") {
      videoId = parsedUrl.pathname.split("/").filter(Boolean)[0] || "";
    }

    if (parsedUrl.hostname.includes("youtube.com")) {
      if (parsedUrl.pathname === "/watch") {
        videoId = parsedUrl.searchParams.get("v") || "";
      } else if (parsedUrl.pathname.startsWith("/shorts/") || parsedUrl.pathname.startsWith("/embed/")) {
        videoId = parsedUrl.pathname.split("/").filter(Boolean)[1] || "";
      }
    }

    if (!videoId) return "";

    const embedUrl = new URL(`https://www.youtube.com/embed/${videoId}`);
    const start = parsedUrl.searchParams.get("start");
    const time = parsedUrl.searchParams.get("t");

    if (start) {
      embedUrl.searchParams.set("start", start);
    } else if (time && /^\d+s?$/.test(time)) {
      embedUrl.searchParams.set("start", time.replace("s", ""));
    }

    return embedUrl.toString();
  } catch (error) {
    return "";
  }
}

cards.forEach((card) => {
  card.querySelector("button").addEventListener("click", () => openDetail(card));
});

mq.addEventListener("change", () => {
  if (!activeId || detail.hidden) return;
  const activeCard = cards.find((card) => card.dataset.shipId === activeId);
  getInsertTarget(activeCard).after(detail);
  updateDetailSliderSpace();
});

window.addEventListener("resize", updateDetailSliderSpace);
